module.exports = __webpack_public_path__ + "img/yyxm.ccc24892.svg";